/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_LedeInputs */

const en_cap_lede = /** @type {(inputs: Cap_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five kinds of system. Each one runs in your tools, inside limits you agree.`)
};

const lv_cap_lede = /** @type {(inputs: Cap_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieci sistēmu veidi. Katra strādā Jūsu rīkos, Jūsu noteiktās robežās.`)
};

/**
* | output |
* | --- |
* | "Five kinds of system. Each one runs in your tools, inside limits you agree." |
*
* @param {Cap_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_lede = /** @type {((inputs?: Cap_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_lede(inputs)
	return en_cap_lede(inputs)
});